import { useWatchlists } from './useWatchlists';

export interface WatchlistMembership {
  watchlistId: string;
  watchlistName: string;
  holdingId: string;
}

interface StockWatchlistStatus {
  isInWatchlist: boolean;
  /** Every watchlist containing this ticker — a stock can be in several. */
  memberships: WatchlistMembership[];
}

/**
 * Derives which of the user's watchlists contain a ticker. Pure read over the
 * already-cached ['watchlists'] query, so it costs no extra request.
 */
export function useIsStockInWatchlist(ticker: string): StockWatchlistStatus {
  const { data: watchlists, isLoading } = useWatchlists();

  if (isLoading || !watchlists || !ticker) {
    return { isInWatchlist: false, memberships: [] };
  }

  const normalisedTicker = ticker.toLowerCase();
  const memberships: WatchlistMembership[] = [];

  for (const watchlist of watchlists) {
    const holding = watchlist.holdings.find((h) => h.ticker.toLowerCase() === normalisedTicker);
    if (holding) {
      memberships.push({
        watchlistId: watchlist.id,
        watchlistName: watchlist.name,
        holdingId: holding.id,
      });
    }
  }

  return { isInWatchlist: memberships.length > 0, memberships };
}
